import React, { useEffect, useState } from "react";
// import Footer from '../Layout/Footer'
// import Header from '../Layout/Header'
// import Sidebar from '../Layout/Sidebar'
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../constants";
import CommonEditor from "./CommonEditor";

const AddProject = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;

  const [projectstatusData, setProjectStatusData] = useState([]);

  const [data, setData] = useState({
    title: editData?.title || "",
    description: editData?.description || "",
    projectId: editData?.projectId?._id || '',
    projectAddress: editData?.projectAddress || '',
    projectUsp: editData?.projectUsp || '',
    position: editData?.position || "",
    link: editData?.link || "",
    // status: editData?.status || '',
    type: editData?.type || "",
    desktopImg: editData?.desktopImg || "",
    mobileImg: editData?.mobileImg || "",
    isActive: editData?.isActive || false,
    statusId: editData?.statusId?._id || "",
  });
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    position: "",
    link: "",
    projectAddress: '',
    projectUsp: '',
    // status: '',
    type: "",
    desktopImg: "",
    mobileImg: "",
    statusId: "",
  });

  const handleChange = (e) => {
    const { name, files, checked, value } = e.target;
    if (name === "desktopImg" || name === "mobileImg") {
      setData({ ...data, [name]: files.length > 0 ? files[0] : null });
    } else if (name === "isActive") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasErrors = false;

    // Validate email
    if (!data.title.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        title: "Title is required",
      }));
      hasErrors = true;
    }
    // if (!data.description.trim()) {
    //     setErrors((prevErrors) => ({
    //         ...prevErrors,
    //         description: 'Description is required'
    //     }));
    //     hasErrors = true;
    // }
    if (!data.position.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        position: "Position is required",
      }));
      hasErrors = true;
    }
    if (!data.link.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        link: "Link is required",
      }));
      hasErrors = true;
    }
    if (!data.projectAddress.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        projectAddress: 'Project address is required'
      }));
      hasErrors = true;
    }
    if (!data.projectUsp.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        projectUsp: 'Project usp is required'
      }));
      hasErrors = true;
    }
    if (!data.type.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        type: "Type is required",
      }));
      hasErrors = true;
    }
    if (!data.desktopImg) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        desktopImg: "Desktop img is required",
      }));
      hasErrors = true;
    }
    if (!data.mobileImg) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobileImg: "Mobile img is required",
      }));
      hasErrors = true;
    }
    if (!data.statusId) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        statusId: "Status is required",
      }));
      hasErrors = true;
    }

    // If there are errors, stop further processing
    if (hasErrors) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("projectAddress", data.projectAddress);
      formData.append("projectUsp", data.projectUsp);
      formData.append("position", data.position);
      formData.append("link", data.link);
      // formData.append("status", data.status);
      formData.append("statusId", data.statusId);
      formData.append("type", data.type);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }
      if (data.mobileImg instanceof File) {
        formData.append("mobileImg", data.mobileImg);
      }
      formData.append("isActive", data.isActive);

      const response = await axiosInstance.post(
        `project/createProject`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/project");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("projectAddress", data.projectAddress);
      formData.append("projectUsp", data.projectUsp);
      formData.append("position", data.position);
      formData.append("link", data.link);
      // formData.append("status", data.status);
      formData.append("statusId", data.statusId);
      formData.append("type", data.type);
      if (data.desktopImg instanceof File) {
        formData.append("desktopImg", data.desktopImg);
      }
      if (data.mobileImg instanceof File) {
        formData.append("mobileImg", data.mobileImg);
      }
      formData.append("isActive", data.isActive);

      const response = await axiosInstance.put(
        `project/updateProject/${editData?._id}`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/project");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const fetchDataStatus = async () => {
    try {
      const response = await axiosInstance.get(
        `project/getWithoutPaginationProjectStatus`
      );
      const { data } = response.data;
      setProjectStatusData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  useEffect(() => {
    fetchDataStatus();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="page-title">Add Project </h3>
        </div>
        <div className="row grid-margin stretch-card">
          <div className="col-md-8  ">
            <div className="card">
              <div className="card-body">
                <form
                  className="pt-3"
                  onSubmit={editData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Title
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="title"
                        name="title"
                        placeholder="Enter title"
                        value={data.title}
                        onChange={handleChange}
                      />
                      {errors.title && (
                        <p className="text-danger">{errors.title}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Description
                    </label>
                    <div className="col-sm-9">
                      <CommonEditor
                        value={data.description}
                        placeholder="Enter content ..."
                        onChange={(value) =>
                          handleChange({
                            target: { name: "description", value },
                          })
                        }
                      />
                      {errors.description && !data?.description?.trim() && (
                        <div className="text-danger">
                          Description is required
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Position
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="position"
                        name="position"
                        placeholder="Enter position"
                        value={data.position}
                        onChange={handleChange}
                      />
                      {errors.position && (
                        <p className="text-danger">{errors.position}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Link
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="link"
                        name="link"
                        placeholder="Enter link"
                        value={data.link}
                        onChange={handleChange}
                      />
                      {errors.link && (
                        <p className="text-danger">{errors.link}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Project Type
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="exampleFormControlSelect1"
                        name="type"
                        value={data.type}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select type --
                        </option>
                        <option value="Residential">Residential</option>
                        <option value="Commercial">Commercial</option>
                      </select>
                      {errors.type && (
                        <p className="text-danger">{errors.type}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Project Status
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="statusId"
                        name="statusId"
                        value={data.statusId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          -- Please Select Status --
                        </option>
                        {projectstatusData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.statusId && (
                        <p className="text-danger">{errors.statusId}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Project Address
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="projectAddress"
                        name="projectAddress"
                        placeholder="Enter project address"
                        value={data.projectAddress}
                        onChange={handleChange}
                      />
                      {errors.projectAddress && <p className="text-danger">{errors.projectAddress}</p>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Project USP
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="projectUsp"
                        name="projectUsp"
                        placeholder="Enter project usp"
                        value={data.projectUsp}
                        onChange={handleChange}
                      />
                      {errors.projectUsp && <p className="text-danger">{errors.projectUsp}</p>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Desktop Img
                    </label>

                    <div className="col-sm-9">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="desktopImg"
                        name="desktopImg"
                        placeholder="Enter desktop img"
                        // value={data.desktopImg}
                        onChange={handleChange}
                      />
                      {errors.desktopImg && (
                        <p className="text-danger">{errors.desktopImg}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Mobile Img
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="mobileImg"
                        name="mobileImg"
                        placeholder="Enter mobile img"
                        // value={data.desktopImg}
                        onChange={handleChange}
                      />
                      {errors.mobileImg && (
                        <p className="text-danger">{errors.mobileImg}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 "
                    >
                      Is Active
                    </label>
                    <div className="col-sm-9">
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="isActive"
                          id="isActiveSwitch"
                          checked={data.isActive}
                          onChange={(e) => handleChange(e)}
                        />
                        <label
                          className="custom-control-label "
                          for="isActiveSwitch"
                        >
                          {data.isActive === true ? "Active" : "Deactive"}
                        </label>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-9"></div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <Link to="/project">
                      <button className="btn btn-secondary mr-2">Back </button>
                    </Link>
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4 stretch-card">
            <div className="card">
              {data?.desktopImg && (
                <div className="w-100 text-center">
                  <p className="mt-3">Desktop Image Preview</p>
                  <br />
                  {data?.desktopImg instanceof File ? (
                    <img
                      src={URL.createObjectURL(data?.desktopImg)}
                      alt="Preview"
                      className="w-50 preview-img"
                    />
                  ) : (
                    <img
                      src={ImageLink(data?.desktopImg)}
                      alt="Preview"
                      className="w-50 preview-img"
                    />
                  )}
                </div>
              )}
              <br />
              <hr />
              {data?.mobileImg && (
                <div className="w-100 h-80 text-center mb-4">
                  <p className="mt-3">Mobile Image Preview</p>
                  <br />
                  {data?.mobileImg instanceof File ? (
                    <img
                      src={URL.createObjectURL(data?.mobileImg)}
                      alt="Preview"
                      className="w-50 preview-img"
                    />
                  ) : (
                    <img
                      src={ImageLink(data?.mobileImg)}
                      alt="Preview"
                      className="w-50 preview-img"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProject;
